import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default () => {
  return (
    <SvgIcon>
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 200 200">
        <path
          d="M150,6.2c9.7,0,17.7,7.3,18.7,16.9l0.1,1.8v40.6c0,3.5-2.8,6.3-6.2,6.3c-3,0-5.6-2.2-6.2-5.1l-0.1-1.1V25
	c0-3-2.2-5.6-5.1-6.1l-1.1-0.1H25c-3,0-5.6,2.2-6.1,5.1L18.8,25v150c0,3,2.2,5.6,5.1,6.1l1.1,0.1h56.5c3.5,0,6.3,2.8,6.3,6.2
	c0,3-2.2,5.6-5.1,6.2l-1.1,0.1H25c-9.7,0-17.7-7.3-18.7-16.9L6.2,175V25c0-9.7,7.3-17.7,16.9-18.7L25,6.2H150z M164.7,95
	c4.5,0,8.6,2.4,10.8,6.3l20.9,36.2c2.2,3.9,2.2,8.6,0,12.5l-20.9,36.2c-2.2,3.9-6.4,6.2-10.8,6.2h-41.8c-4.5,0-8.6-2.4-10.8-6.2
	L91.1,150c-2.2-3.9-2.2-8.6,0-12.5l20.9-36.2c2.2-3.9,6.4-6.2,10.8-6.2H164.7L164.7,95z M164.7,107.5h-41.8l-20.9,36.2l20.9,36.2
	h41.8l20.9-36.2L164.7,107.5L164.7,107.5z M143.8,125c10.4,0,18.8,8.4,18.8,18.8s-8.4,18.8-18.8,18.8s-18.8-8.4-18.8-18.8
	S133.4,125,143.8,125z M143.8,137.5c-3.5,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2s6.2-2.8,6.2-6.2S147.2,137.5,143.8,137.5z M75.1,81.2
	c3.5,0,6.3,2.8,6.3,6.2c0,3-2.2,5.6-5.1,6.2l-1.1,0.1h-25c-3.5,0-6.3-2.8-6.3-6.2c0-3,2.2-5.6,5.1-6.2l1.1-0.1H75.1z M100,45.6
	c3.5,0,6.3,2.8,6.3,6.2c0,3-2.2,5.6-5.1,6.2l-1.1,0.1H50.1c-3.5,0-6.3-2.8-6.3-6.2c0-3,2.2-5.6,5.1-6.2l1.1-0.1
	C50.1,45.6,100,45.6,100,45.6z"
        />
      </svg>
    </SvgIcon>
  );
};
